<template>
  <div class="container-season-selector">
    <div class="container-logo-agrofull">
      <!-- <img src="https://agrofull.codiflix.com/images/logo-solo.svg"> -->
      <img class="logo-agrofull" src="../assets/img/logo-solo.svg">
    </div>
    <!-- <div class="season-selector">
      <div :class="this.currentPlanData.season === 'summer' ? 'season selected-season selSummer' : 'season'" id="summer"
        @click="selectSeason('summer')">Verano</div>
      <div :class="this.currentPlanData.season === 'winter' ? 'season selected-season selWinter' : 'season'" id="winter"
        @click="selectSeason('winter')">Invierno</div>
    </div> -->
    <div class="nombre-del-plan">
      <label class="col-12 mb-2">
        <!-- Nombre del plan -->
        <n-input placeholder="Nombre del plan" v-model:value="currentPlanData.name"></n-input>
      </label>
    </div>
  </div>
  
  <ResetPlanModal v-if="showResetPlanModal" @triggerCloseModal="showResetPlanModal = false"/>
</template>
<script>
import { mapActions, mapState } from 'pinia';
import planStore from '../store/plan';
import ResetPlanModal from './resetPlanModal.vue';

export default {
  name: "season-selector",
  data() {
    return {
      showResetPlanModal: false,
    };
  },
  computed: {
    ...mapState(planStore, ["currentPlanData"])
  },
  methods: {
    ...mapActions(planStore, ["updateCurrentPlanData"]),
    async selectSeason(season) {
      let isProductSelected = false;
      for (let division of this.currentPlanData.divisions) {
        if (division.product)
          isProductSelected = true;
      }
      if (isProductSelected && this.currentPlanData.season != season) {
        this.showResetPlanModal = true;
        return;
      }
      await this.updateCurrentPlanData({ season: season }, "season");
    }
  },
  components: { ResetPlanModal }
}
</script>
<style scoped>

.container-season-selector {
  display: flex;
  justify-content: center; 
  align-items: center;
  position: absolute;
}


.container-logo-agrofull {
  z-index: 1;
  width: 40vw;
  margin-left: -60vw;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.logo-agrofull {
  /* width: 23vw; */
  width: 12rem;
  height: 3rem;
  margin-top: 1.5rem;
  margin-left: 15%;
}
.season-selector {
  width: 50vw;
  max-width: 740px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 2rem;
  left: -14vw;
  /* border: 1px solid var(--dark-gray); */
  height: 2.7rem;
  border-radius: 0.75rem;
  background-color: var(--light-gray);
}

.nombre-del-plan {
  width: 50vw;
  max-width: 740px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 2rem;
  left: -14vw;
  /* border: 1px solid var(--dark-gray); */
  height: 2.7rem;
  border-radius: 0.75rem;
  background-color: var(--light-gray);  
}



.season {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 0.8rem;
  user-select: none;
  color: var(--medium-gray);
}

.selected-season {
  background-color: var(--interaction-yellow);
  font-size: 1.2rem;
  color: white;
}

#summer {
  border-right: 1px solid var(--dark-gray);
  border-radius: 0.75rem 0 0 0.75rem;
}

#winter {
  border-radius: 0 0.75rem 0.75rem 0;
}


@media screen and (max-width: 700px) {

  .container-logo-agrofull {
    z-index: 1;
    width: 40vw;
    margin-left: -60vw;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .logo-agrofull {
    /* width: 23vw; */
    width: 7.0625rem;
    height: 2.7rem;
    margin-top: 0.3rem;
    margin-left: 1rem;
  }
  
  .season-selector {
    height: 2.2rem;
    width: 50vw;
    top: 1rem;
    left: -4vw;
  }

  .nombre-del-plan {
    height: 2.2rem;
    width: 40vw;
    top: 1.1rem;
    left: 5vw;
  }



}
</style>